import type { OrderFilters } from '@models/order'
import { useMutation, useQueryClient } from 'react-query'
import { stopsKeys } from '../stops'
import ordersApi from './actions'
import { ordersKeys } from './constants'

const useOrdersMutations = (filters?: OrderFilters) => {
  const queryClient = useQueryClient()

  const cancelOrder = useMutation(ordersApi.cancelOrder, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(ordersKeys.orders(filters))
    },
  })

  const bulkAcceptOrder = useMutation(ordersApi.bulkAcceptOrder, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(stopsKeys.root())
    },
  })

  const finishStop = useMutation(ordersApi.finishStop, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(stopsKeys.root())
    },
  })

  return { cancelOrder, bulkAcceptOrder, finishStop }
}

export default useOrdersMutations
